import { Settings } from '../models/settings';

export const SETTINGS_UPDATE = 'SETTINGS_UPDATE';

export const settingsUpdate = (settings: Partial<Settings>) => {
    return {
        type: SETTINGS_UPDATE,
        settings,
    };
};
